import {
  formSpecification as commonFormSpecification,
  type McaIncidentDetailsFormData as CommonMcaIncidentDetailsFormData,
} from "../common/mcaIncidentDetails.js";

export const formSpecification = commonFormSpecification;

export type McaIncidentDetailsFormData = CommonMcaIncidentDetailsFormData;
